
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      festival: 'settings/festival'
    })
  }
};
